/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-pascal-case */
import React, { useState } from 'react';
import { Container, Typography, Alert, Box, Card, CardContent } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { colors } from '../../customTheme';
import ShareNowPlaceholder from '../../images/assistant/share_now_placeholder.png';
import useExtensionVersion from '../../hooks/useExtensionVersion.ts';
import Dashboard from '../dashboard/Dashboard.tsx';
import { Experimental_CssVarsProvider } from '@mui/material/styles';

const PlaceholderCard = () => {
  return (
    <Box paddingBottom={2}>
      <Card variant="outlined">
        <CardContent>
          <img
            src={ShareNowPlaceholder}
            alt="Share now placeholder"
            style={{
              maxWidth: '100%',
              height: 'auto',
              filter: 'grayscale(100%)',
              pointerEvents: 'none'
            }} />
        </CardContent>
      </Card>
    </Box>
  );
}

const Assistant = ({ title, subtitle, description, href }) => {
  const { showExtensionInstallWarning, installExtensionMessage } = useExtensionVersion();

  const [settings, setSettings] = useState({
    offerToLikers: {
      enabled: false,
      discountPercentage: '0.1',
      shippingDiscount: '50'
    },
    shippingDiscountOptions: [
      {
        label: 'Free shipping on orders over $50',
        value: '50'
      },
      {
        label: 'Free shipping on orders over $100',
        value: '100'
      },
    ],
    shareCloset: {
      enabled: true,
      alarms: [
        {
          name: "Morning",
          enabled: true,
          startAt: new Date()
        },
        {
          name: "Afternoon",
          enabled: true,
          startAt: new Date()
        },
        {
          name: "Evening",
          enabled: true,
          startAt: new Date()
        },
        {
          name: "Night",
          enabled: true,
          startAt: new Date()
        }
      ]
    },
  })

  return (
    <Dashboard>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content="Closet Sharer" />
        <meta property="og:description" content="Automatically share your closet and make more sales." />
        <meta property="og:url" content="https://poshwatch.io/poshmark-assistant" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href={href} />
      </Helmet>

      <Experimental_CssVarsProvider>
        <Alert
          variant="soft"
          color="success"
          sx={{
            maxWidth: '600px',
            width: '100%',
          }}
        >
          We are currently reworking the chrome extension and web app to provide you with an even better experience.
          <br /><br />
          In the meantime, please use the mobile app for closet sharing and offers to likers.
        </Alert>

        <Box>
          <Typography variant='h1'
            style={{
              fontSize: "1.8em",
              fontWeight: 'bold',
              color: colors.mineShaft,
              fontFamily: "Libre Baskerville"
            }}
          >{title}
          </Typography>
          <Typography
            color="textSecondary"
            variant="body1"
            sx={{ pt: 2, pb: 2 }}
          >{subtitle}
          </Typography>
        </Box>
        {showExtensionInstallWarning &&
          <Box>
            <a
              href="https://chromewebstore.google.com/detail/poshwatch/mkcklccefjfbljhgabgdnapimbmejlpo"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <Alert
                severity={'error'}
                style={{
                  marginBottom: '12px',
                }}
              >
                {installExtensionMessage}
              </Alert>
            </a>
            <PlaceholderCard />
          </Box>
        }
        {showExtensionInstallWarning === false && <div id={"extension-container"} />}
      </Experimental_CssVarsProvider>
    </Dashboard>
  );
};

export default Assistant;
